module.exports = __webpack_public_path__ + "static/media/galerija_2021 (8).bf7f7816.jpg";